import * as angular from "angular";
import {IController, IFilterService} from "angular";
import * as _ from "lodash";
import {$agentsFactory} from "../../$agents.factory";

export class AgentAutocompleteCtrl implements IController {

  label: any;
  allowClear: any;
  avoidIds: any;

  onSelect: Function;

  private searchQuery: string;
  private agentsRef: any;

  constructor(private $agents: $agentsFactory, private $filter: IFilterService, private $log) {
  }

  $onInit() {
    this.searchQuery = null;
    this.agentsRef = this.$agents();

    if (!this.label) {
      this.label = 'Search Drivers';
    }
  };

  agentNameFilter(agent) {
    return this.$filter<any>('userName')(agent.user);
  }

  onSearch(searchQuery) {
    return new Promise((resolve, reject) => {
      const query = {
        isDemand : false,
        limit : 10,
        descending : true,
        query : searchQuery,
        active: true
      };

      this.agentsRef.$getAll(query)
        .then((agentIds) => {
          if (this.avoidIds && !_.isEmpty(this.avoidIds)) {
            agentIds = _.filter(agentIds, (agentId) => {
              return _.indexOf(this.avoidIds, agentId) === -1
            })
          }
          return this.agentsRef.$asyncValues(agentIds)
        })
        .then((agents) => {
          resolve(agents);
        })
        .catch((error) => {
          this.$log.error('Failed to search agent, ' +
            'agentAutocompleteCtrl@onSearch( \n' + error);
          reject(error);
        })
    });
  }

  onSelectItem(item) {
    if (item) {
      if (this.allowClear) {
        this.searchQuery = null;
      }
      this.onSelect({agent: item})
    }
  }


}

angular
  .module('bringoz.admin.agents')
  .component('agentAutocomplete', {
    bindings: {
      label: '<?',
      allowClear: '<',
      avoidIds: '<?',
      onSelect: '&'
    },
    template: require('./agent-autocomplete.html').default,
    controller: AgentAutocompleteCtrl
  });
